import { Action } from 'redux'

import { File } from 'src/lib/interfaces/File.interface'
import { QACheck } from 'src/lib/interfaces/QACheck.interface'
import { BaseReportFilterParameters } from 'src/lib/interfaces/BaseReportFilterParameters.interface'

export const actionTypes = {
	// fetch qa checks list
	QA_CHECKS_FETCH_LIST: 'QA_CHECKS_FETCH_LIST',
	QA_CHECKS_FETCH_LIST_FAILED: 'QA_CHECKS_FETCH_LIST_FAILED',
	QA_CHECKS_FETCH_LIST_SUCCESS: 'QA_CHECKS_FETCH_LIST_SUCCESS',

	// files
	QA_CHECKS_FETCH_FILES: 'QA_CHECKS_FETCH_FILES',
  QA_CHECKS_FETCH_FILES_FAILED: 'QA_CHECKS_FETCH_FILES_FAILED',
  QA_CHECKS_FETCH_FILES_SUCCESS: 'QA_CHECKS_FETCH_FILES_SUCCESS',

	// filter params
	QA_CHECKS_SET_FILTER_PARAMS: 'QA_CHECKS_SET_FILTER_PARAMS',
	QA_CHECKS_FILTER_PARAMS_RESET: 'QA_CHECKS_FILTER_PARAMS_RESET',

	// current
	QA_CHECKS_SET_CURRENT: 'QA_CHECKS_SET_CURRENT',
  QA_CHECKS_SET_CURRENT_FAILED: 'QA_CHECKS_SET_CURRENT_FAILED',
  QA_CHECKS_SET_CURRENT_SUCCESS: 'QA_CHECKS_SET_CURRENT_SUCCESS'
}

/**
 * Fetch qa checks list
 */
export interface QAChecksFetchListAction extends Action {
	payload: {
		next?: (err?: any, qaChecks?: QACheck[]) => void
	}
}

export const fetchQAChecksList = (
	next?: (err?: any, qaChecks?: QACheck[]) => void,
): QAChecksFetchListAction => ({
	type: actionTypes.QA_CHECKS_FETCH_LIST,
	payload: { next },
})

// Success
export interface QAChecksFetchListSuccessAction extends Action {
	payload: {
		qaChecks: QACheck[]
	}
}

export const fetchQAChecksListSuccess = (
	qaChecks: QACheck[],
): QAChecksFetchListSuccessAction => ({
	type: actionTypes.QA_CHECKS_FETCH_LIST_SUCCESS,
	payload: { qaChecks },
})

// Error
export interface QAChecksFetchListErrorAction extends Action {
	payload: {
		errorMessage?: string
	}
}

export const fetchQAChecksListError = (
	errorMessage: string,
): QAChecksFetchListErrorAction => ({
	type: actionTypes.QA_CHECKS_FETCH_LIST_FAILED,
	payload: {
		errorMessage,
	},
})

/**
 * Fetch qa check files
 */
export interface QAChecksFetchFilesAction extends Action {
	payload: {
		qaCheckId: string
	}
}

export const fetchQACheckFiles = (qaCheckId: string): QAChecksFetchFilesAction => ({
	type: actionTypes.QA_CHECKS_FETCH_FILES,
	payload: { qaCheckId }
})

// Success
export interface QAChecksFetchFilesSuccessAction extends Action {
	payload: {
		files: File[]
		qaCheckId: string,
	}
}

export const fetchQACheckFilesSuccess = (files: File[], qaCheckId: string): QAChecksFetchFilesSuccessAction => ({
	type: actionTypes.QA_CHECKS_FETCH_FILES_SUCCESS,
	payload: { files, qaCheckId }
})

// Error
export interface QAChecksFetchFilesErrorAction extends Action {
	payload: {
		errorMessage?: string
	}
}

export const fetchQACheckFilesFailed = (errorMessage?: string): QAChecksFetchFilesErrorAction => ({
	 type: actionTypes.QA_CHECKS_FETCH_FILES_FAILED,
	 payload: { errorMessage }
 })

/**
 * Reset filter params
 */
export interface QAChecksFilterParamsResetAction extends Action {
	payload: {
		filterParams?: BaseReportFilterParameters
	}
}

export const resetQAChecksFilterParams = (
	filterParams?: BaseReportFilterParameters,
): QAChecksFilterParamsResetAction => ({
	type: actionTypes.QA_CHECKS_SET_FILTER_PARAMS,
	payload: { filterParams },
})

/**
 * Update filter
 */
export interface QAChecksSetFilterParamsAction extends Action {
	payload: {
		filterParams: BaseReportFilterParameters
	}
}

/**
 * Set current QA check
 */
 export interface QAChecksSetCurrentAction extends Action {
  payload: {
    qaCheck?: QACheck
  }
}

export const setCurrentQACheck = (qaCheck?: QACheck): QAChecksSetCurrentAction => ({
  type: actionTypes.QA_CHECKS_SET_CURRENT,
  payload: { qaCheck }
})

// success
export interface QAChecksSetCurrentSuccessAction extends Action {
  payload: {
    qaCheck: QACheck
  }
}

export const setCurrentQACheckSuccess = (qaCheck: QACheck): QAChecksSetCurrentSuccessAction => ({
  type: actionTypes.QA_CHECKS_SET_CURRENT_SUCCESS,
  payload: { qaCheck }
})

// error
export interface QAChecksSetCurrentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const setCurrentQACheckError = (errorMessage?: string): QAChecksSetCurrentErrorAction => ({
  type: actionTypes.QA_CHECKS_SET_CURRENT_FAILED,
  payload: { errorMessage }
})

export const setQAChecksFilterParams = (
	filterParams: BaseReportFilterParameters,
): QAChecksSetFilterParamsAction => ({
	type: actionTypes.QA_CHECKS_SET_FILTER_PARAMS,
	payload: { filterParams },
})

export type ActionTypes =
	| QAChecksFetchListAction
	| QAChecksFetchListSuccessAction
	| QAChecksFetchListErrorAction
	| QAChecksFilterParamsResetAction
	| QAChecksSetFilterParamsAction
	| QAChecksSetCurrentAction
	| QAChecksSetCurrentSuccessAction
	| QAChecksSetCurrentErrorAction



// WEBPACK FOOTER //
// ./src/store/qaChecks/actions.ts